import {RootStore} from './RootStore';
import {action} from 'mobx';
import agent from '../api/agent';
import { StudyEvaluationParam, HistoryParam, ProgramGenerateParam, GenerateSPParam, GenerateLogParam } from "../models/StudyEvaluation";

export default class StudyEvaluationStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
      this.rootStore = rootStore;
    }

    @action getProcessList = async (param:StudyEvaluationParam) => {
        try 
        {   
            const list = await agent.StudyEvaluation.processList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action processApproval = async (param:any) => {
        try 
        {   
            const list = await agent.StudyEvaluation.processApproval(param);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getHistoryList = async (param:HistoryParam) => {
        try 
        {   
            const list = await agent.StudyEvaluation.historyList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action getHistoryDetail = async (history_id: number) => {
        try 
        {   
            const list = await agent.StudyEvaluation.historyDetail(history_id);
            return list.result[0];
        } catch (error) {
            throw error;
        }
    };

    @action getProgramGenerateList = async (param: ProgramGenerateParam) => {
        try 
        {   
            const list = await agent.StudyEvaluation.programGenerateList(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action generateSP = async (param: GenerateSPParam) => {
        try 
        {   
            const list = await agent.StudyEvaluation.generateSP(param);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action generateLog = async (param: GenerateLogParam) => {
        try 
        {   
            const list = await agent.StudyEvaluation.generateLog(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action getDiffGpa = async (param:any) => {
        try 
        {   
            const list = await agent.StudyEvaluation.getDiffGpa(param);
            return list.result;
        } catch (error) {
            throw error;
        }
    };


}